import React from "react";

const styles: { [k: string]: React.CSSProperties } = {
  footer: { padding: "24px 32px", borderTop: "1px solid #e6edf3", marginTop: 24, fontSize: 13, color: "#64748b" },
};

const getTemaNameByHostname = (hostname: string): string => {
  switch (hostname) {
    // Add more cases for different hostnames and their corresponding tema names
    case 'localhost':
      return 'Easyride';
    case 'www.ridego.me':
      return 'Ride Go';
    default:
      return 'DefaultTema';
  }
}

const FooterUberTaxi: React.FC = () => (
  <footer style={styles.footer}>
    <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div>© {new Date().getFullYear()} {getTemaNameByHostname(window.location.hostname)} — 建立高效的車隊營運團隊</div>
      <div style={{ display: "flex", gap: 12 }}>
        <a href="/terms" style={{ color: "#64748b", textDecoration: "none" }}>服務條款</a>
        <a href="/privacy" style={{ color: "#64748b", textDecoration: "none" }}>隱私政策</a>
      </div>
    </div>
  </footer>
);

export default FooterUberTaxi;
